export function setCanonical(path) {
  let link = document.getElementById('canonical-link');
  if (!link) {
    link = document.createElement('link');
    link.id = 'canonical-link';
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  const base = window.location.origin;
  link.href = `${base}${path}`;
}

export function setMeta(title, description) {
  document.title = title ? `${title} | TrueFitGuide` : 'TrueFitGuide - Find Your Perfect Fit Across 50+ Brands';
  let desc = document.querySelector('meta[name="description"]');
  if (!desc) {
    desc = document.createElement('meta');
    desc.name = 'description';
    document.head.appendChild(desc);
  }
  desc.content = description || 'Free clothing size converter and fit finder for 50+ global brands. Convert sizes between US, UK, EU, Japan, and Korea instantly.';
}
